module.exports = __webpack_public_path__ + "img/4_of_Clubs.svg.a4fb7014.png";